import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import FontSizeContainer from './fontSize/FontSizeContainer';
import LineHeightContainer from './lineHeight/LineHeightContainer';
import IndentRightContainer from './indentRight/IndentRightContainer';
import IndentLeftContainer from './indentLeft/IndentLeftContainer';
import IndentTopContainer from './indentTop/IndentTopContainer';
import FontTypeContainer from './fontType/FontTypeContainer';
import CustomFontContainer from './customFont/CustomFontContainer';
import TextColorContainer from './textColor/TextColorContainer';
import IndentRedLineContainer from './indentRedLine/IndentRedLineContainer';
import IndentLetterContainer from './indentLetter/IndentLetterContainer';
import RandomFontSizeContainer from './randomfontSize/RandomFontSizeContainer';
import RandomRotateLetterContainer from './randomRotateLetter/RandomRotateLetterContainer';
import RandomLineLeftIndentContainer from './randomLineLeftIndent/RandomLineLeftIndentContainer';
import { AppStateTypes } from '../../store/appStateTypes';
import { setItem } from '../../helpers/localStorage';
import { LOCAL_STORAGE_TEXT_SETTINGS } from '../../constants/localStorageConstants';

const TextSettingsContainer = () => {
  const textSettings = useSelector((state: AppStateTypes) => state.textSettings);

  useEffect(() => {
    setItem(LOCAL_STORAGE_TEXT_SETTINGS, textSettings);
  }, [textSettings]);

  return (
        <>
            <FontTypeContainer />
            <RandomFontSizeContainer />
            <RandomRotateLetterContainer />
            <RandomLineLeftIndentContainer />
            <FontSizeContainer />
            <LineHeightContainer />
            <IndentRightContainer />
            <IndentLeftContainer />
            <IndentLetterContainer />
            <IndentRedLineContainer />
            <IndentTopContainer />
            <TextColorContainer />
            <CustomFontContainer />
        </>
  );
};

export default TextSettingsContainer;
